export const pobMunicipio_item = [
  {
    comparecencias_item_nombre: "Universo Población SSH 2020 (17 Jurisdicciones)",
    comparecencias_item_url: "../../../contenido/informacion/publicaciones/Universo_Población_SSH_2020.pdf",
    comparecencias_item_titulo: "Año 2020"
  },
  {
    comparecencias_item_nombre: "Universo Población SSH 2023 (12 Jurisdicciones)",
    comparecencias_item_url: "../../../contenido/informacion/publicaciones/Universo_Poblacion_SSH_2023.pdf",
    comparecencias_item_titulo: "Año 2023"
  },
  {
    comparecencias_item_nombre: "Universo Población SSH 2024 (12 Jurisdicciones)",
    comparecencias_item_url: "../../../contenido/informacion/Universo_Poblacion_SSH_2024.pdf",
    comparecencias_item_titulo: "Año 2024"
  },
];
